import PropTypes from "prop-types"
import { Avatar, ListItemAvatar, ListItem, ListItemText, Button } from "@mui/material"
import { ErrorOutlined } from "@mui/icons-material"
import { appendTimestamp } from "modules/server-notifications/helpers"
import withNavigate from "hocs/withNavigate"

function Error({ navigate, message, targetName, action, createdAt }) {
  const secondaryAction = action ? <Button color="primary" onClick={() => action.fn(navigate)}>
    {action.text}
  </Button> : null

  return <ListItem secondaryAction={secondaryAction}>
    <ListItemAvatar>
      <Avatar className="error">
        <ErrorOutlined />
      </Avatar>
    </ListItemAvatar>
    <ListItemText primary={message} secondary={appendTimestamp(targetName, createdAt)} />
  </ListItem>
}

Error.propTypes = {
  navigate: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  targetName: PropTypes.string.isRequired,
  action: PropTypes.func.isRequired,
  createdAt: PropTypes.string.isRequired,
}

export default withNavigate(Error)
